module.exports = __webpack_public_path__ + "img/20220805141414.4b30f2f8.jpg";